import axios, { InternalAxiosRequestConfig } from "axios";
import { validateUser } from "../reducers/auth";
import { version } from "../config/constants";
import storage from "utils/storage";
import { Store } from "redux";

export default (store: Store) => {
  const { isSignedIn } = store.getState().auth;
  if (isSignedIn) {
    store.dispatch(validateUser());
  }

  axios.interceptors.request.use((config) => {
    config.headers = {
      ...config.headers,
      "access-token": storage.get("access-token"),
      client: storage.get("client"),
      uid: storage.get("uid"),
      "X-App-Version": version,
    }
    return config;
  }, error => Promise.reject(error));

  axios.interceptors.response.use((response) => {
    if (response.headers["access-token"]){
      storage.set("access-token", response.headers["access-token"]);
      storage.set("client", response.headers["client"]);
      storage.set("uid", response.headers["uid"]);
    }
    return response;
  }, error => {
    if (error.response && error.response.status === 401 && window.location.hash !== '#/signin'){
      window.location.reload();
    }
    return Promise.reject(error);//{ errors: error.response.data.errors };
  });
}
